import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { ExpandMoreRounded as ExpandIcon, TopicOutlined as GeneralJournalIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';

export const generalJournalItemsConfig = [
  {
    label: 'General Journal - AP',
    to: '/general-journal/AP?status=pending&is_posted=0',
    permission: 34,
  },
  {
    label: 'General Journal - AR',
    to: '/general-journal/AR?status=pending&is_posted=0',
    permission: 60,
  },
  {
    label: 'General Journal - Accrual & Reversal',
    to: '/general-journal/accrual-and-reversal?isstatus=pending&_reversed=0',
    permission: 43,
  },
  {
    label: 'General Journal - Accrual Reversal',
    to: '/general-journal/accruals-and-reversals?isstatus=pending&_reversed=0',
    permission: 84,
  },

  {
    label: 'General Journal - Treasury - 12',
    to: '/general-journal/treasury-12?status=pending&is_posted=0',
    permission: 44,
  },
  {
    label: 'General Journal - Treasury - 22',
    to: '/general-journal/treasury-22?status=pending&is_posted=0',
    permission: 86,
  },
  {
    label: 'General Journal - Cost & Budget - 12',
    to: '/general-journal/cost-and-budget-12?status=pending&is_posted=0',
    permission: 45,
  },
  {
    label: 'General Journal - Cost & Budget - 22',
    to: '/general-journal/cost-and-budget-22?status=pending&is_posted=0',
    permission: 73,
  },
  {
    label: 'General Journal - Cost & Budget - 30',
    to: '/general-journal/cost-and-budget-30?status=pending&is_posted=0',
    permission: 74,
  },
  {
    label: 'General Journal - Fixed Asset - 12',
    to: '/general-journal/fixed-asset-12?status=pending&is_posted=0',
    permission: 46,
  },
  {
    label: 'General Journal - Fixed Asset - 22',
    to: '/general-journal/fixed-asset-22?status=pending&is_posted=0',
    permission: 72,
  },
  {
    label: 'General Journal - Confidential - 12',
    to: '/general-journal/confidential-12?status=pending&is_posted=0',
    permission: 47,
  },
  {
    label: 'General Journal - Confidential - 22',
    to: '/general-journal/confidential-22?status=pending&is_posted=0',
    permission: 78,
  },
  {
    label: 'General Journal - Confidential - 30',
    to: '/general-journal/confidential-30?status=pending&is_posted=0',
    permission: 97,
  },
  {
    label: 'General Journal - Sales',
    to: '/general-journal/sales?status=pending&is_posted=0',
    permission: 57,
  },
  {
    label: 'General Journal - FO',
    to: '/general-journal/FO?status=pending&is_posted=0',
    permission: 58,
  },
  {
    label: 'General Journal - Live',
    to: '/general-journal/live?status=pending&is_posted=0',
    permission: 59,
  },
  {
    label: 'General Journal - AP Specialist - 12',
    to: '/general-journal/ap-specialist-12?status=pending&is_posted=0',
    permission: 66,
  },
  {
    label: 'General Journal - AP Specialist - 22',
    to: '/general-journal/ap-specialist-22?status=pending&is_posted=0',
    permission: 66,
  },
  {
    label: 'General Journal - PCF',
    to: '/general-journal/pcf?status=pending&is_posted=0',
    permission: 67,
  },
    {
    label: 'General Journal - Year End',
    to: '/general-journal/year-end?status=pending&is_posted=0',
    permission: 99,
  },
  {
    label: 'General Journal - Confidential Year End',
    to: "/general-journal/confidential-year-end?status=pending&is_posted=0",
    permission: 101
  }
];

const SidebarGeneralJournalDropdown = ({
  activeDropdown,
  user,
  journals,
  cheque,
  shouldDisplayDotNotification,
  isJournalsLoading,
  isChequeLoading,
  RouterLink,
  DisplayBubbleNotification,
}) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/general-journal/gi));
  const isNotApproving = !Boolean(activeDropdown?.match(/approval/gi));

  return (
    <Accordion elevation={0} square disableGutters>
      <AccordionSummary
        className={isActiveDropdown && isNotApproving ? `FstoSidebarActiveDropdown-root ${color}` : `FstoSidebarDropdown-root ${color}`}
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <GeneralJournalIcon />
        <Typography variant="sidebar">General Journals</Typography>
      </AccordionSummary>
      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {generalJournalItemsConfig.map(
          (item) =>
            user.permissions.includes(item?.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
              </RouterLink>
            ),
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarGeneralJournalDropdown;
